<script>
  import Icon from 'svelte-hero-icons';
  import GenericButton from '../button/GenericButton.svelte';
  import Form from '../form/Form.svelte';
  import { createEventDispatcher } from 'svelte';

  //data is an object that receives any data from the source component
  export let modalData;
  const dispatch = createEventDispatcher()

  function submitAction(){
    dispatch('modalSubmit');
    dispatch('reload');
  }
</script>

<div on:click|self class="modal z-[101]" on:keyup={()=>console.log()}>
  <div class="content" on:click on:keyup={()=>console.log()}>
    <div class="header">
      {#if modalData.Icon != null}
        <Icon
          src={modalData.Icon}
          solid
          class="mr-2.5 h-10 w-10 outline-none text-orange-500"
        />
      {/if}
      {modalData.headerText}
    </div>
    <div class="body text-gray-400">
      {modalData.body}
    </div>
    <Form on:submit={submitAction}>
      <button style="border: none;" on:click>
        <GenericButton text="Cancel" buttonTheme="grey-light" width="6rem" onClick />
      </button>
      <GenericButton
        submit="true"
        text={modalData.rightButtonText}
        buttonTheme={modalData.rightButtonType}
        width="6rem"
        onClick={submitAction}
      />
    </Form>
  </div>
</div>

<style>
  .body {
    margin: 2rem 0;
  }
  .header {
    font-weight: bold;
    display: flex;
    text-align: center;
    justify-content: center;
    font-size: 24px;
  }

  .modal {
    background-color: rgba(0, 0, 0, 0.4);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
    margin: 0 !important;
  }

  .content {
    background-color: #ffffff;
    width: 25rem;
    height: auto;
    max-height: 36rem;
    align-items: center;
    text-align: center;
    margin: auto;
    padding: 2rem;
    border-radius: 5px;
  }
</style>
